document.addEventListener('DOMContentLoaded', function() {
  const tabLinks = document.querySelectorAll('.tabs ul li');
  for (let i = 0; i < tabLinks.length; i++) {
    tabLinks[i].addEventListener('click', function(e) {
      let activeTab = e.target.attributes['data-tab-target'].value;
      tabLinks.forEach(function( tabElement ){
        tabElement.classList.remove('active');
      });
      e.target.parentNode.classList.add('active');
      showTab(activeTab);
      e.preventDefault();
    });
  }
  function showTab(tabElementId) {
    const tabElements = document.querySelectorAll('.tab-item');
    for (let i = 0; i < tabElements.length; i++) {
      tabElements[i].classList.add('hidden');
      tabElements[i].classList.remove('active');
    }
    const tabElement = document.querySelector(`#${tabElementId}`);
    tabElement.classList.remove('hidden')
    tabElement.classList.add('active');
  }
});